const FAVORITES_KEY = 'aubuchon_home_favorites_v1'

function hasLocalStorage() {
	try {
		return typeof window !== 'undefined' && 'localStorage' in window && window.localStorage !== null
	} catch (error) {
		return false
	}
}

function normalizeId(id) {
	if (id === null || id === undefined) {
		return ''
	}

	return String(id).trim()
}

function readFavorites() {
	if (!hasLocalStorage()) {
		return []
	}

	try {
		const rawValue = window.localStorage.getItem(FAVORITES_KEY)
		const parsed = rawValue ? JSON.parse(rawValue) : []

		if (!Array.isArray(parsed)) {
			return []
		}

		return parsed.map(normalizeId).filter(Boolean)
	} catch (error) {
		return []
	}
}

function writeFavorites(favorites) {
	if (!hasLocalStorage()) {
		return
	}

	window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites))
}

export function getFavoriteHomeIds() {
	return readFavorites()
}

export function isHomeFavorite(homeId) {
	const normalizedId = normalizeId(homeId)

	if (!normalizedId) {
		return false
	}

	return readFavorites().includes(normalizedId)
}

export function toggleHomeFavorite(homeId) {
	const normalizedId = normalizeId(homeId)
	const favorites = readFavorites()
	let nextFavorites = favorites
	let isFavorite = false

	if (!normalizedId) {
		return {
			isFavorite: false,
			favorites,
		}
	}

	if (favorites.includes(normalizedId)) {
		nextFavorites = favorites.filter(function (id) {
			return id !== normalizedId
		})
		isFavorite = false
	} else {
		nextFavorites = favorites.concat(normalizedId)
		isFavorite = true
	}

	writeFavorites(nextFavorites)

	if (typeof window !== 'undefined') {
		window.dispatchEvent(
			new CustomEvent('aubuchon:favorites-updated', {
				detail: {
					favorites: nextFavorites,
				},
			})
		)
	}

	return {
		isFavorite,
		favorites: nextFavorites,
	}
}
